import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Building2, X, Shield, Users } from 'lucide-react';
import { useTheme } from '../../hooks/useTheme';

const CompleteProfileModal = ({ onClose }) => {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const dark = theme === 'dark';

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50">
      <div className={`relative w-full max-w-[500px] rounded-2xl shadow-2xl overflow-hidden
        ${dark ? 'bg-[#1a1f2e] border border-gray-700/40' : 'bg-white border border-gray-100'}`}>

        {/* Close button */}
        {/* <button
          onClick={onSkip}
          className="absolute top-4 right-4 z-10 p-1 rounded-full hover:opacity-70 transition-opacity"
        >
          <X size={18} className={dark ? 'text-gray-400' : 'text-gray-500'} />
        </button> */}

        {/* ── Illustration area ── */}
        <div className={`w-full flex items-center justify-center
            ${dark ? 'bg-[#1e2436]' : 'bg-[#f0f1ff]'}`}>
            <img
                src={dark ? '/company-profile-dark.png' : '/company-profile-light.png'}
                alt="Complete your profile"
                className="w-full object-contain"
            />
            </div>

        {/* ── Text content ── */}
        <div className="px-8 pt-6 pb-4 text-center">
          <h2 className={`text-xl font-bold mb-2 ${dark ? 'text-white' : 'text-gray-900'}`}>
            Complete Your Company Profile
          </h2>
          <p className={`text-sm leading-relaxed ${dark ? 'text-gray-400' : 'text-gray-500'}`}>
            Complete your company profile to ensure your company details are visible in all candidate communication like Emails, ATS 
          </p>
        </div>

        {/* ── 3 feature pills ── */}
        <div className="flex justify-center gap-3 px-6 py-4">
          {[
            { icon: <Building2 size={14} />, text: 'Show your company information', color: 'text-indigo-500 bg-indigo-50 dark:bg-indigo-900/20' },
            { icon: <Shield size={14} />, text: 'Build trust with candidates', color: 'text-green-500 bg-green-50 dark:bg-green-900/20' },
            { icon: <Users size={14} />, text: 'Professional experience for customers', color: 'text-purple-500 bg-purple-50 dark:bg-purple-900/20' },
          ].map(({ icon, text, color }, i) => (
            <div key={i} className="flex flex-col items-center gap-1.5 text-center flex-1">
              <div className={`w-8 h-8 rounded-full flex items-center justify-center ${color}`}>
                {icon}
              </div>
              <p className={`text-[10px] leading-tight ${dark ? 'text-gray-400' : 'text-gray-500'}`}>
                {text}
              </p>
            </div>
          ))}
        </div>

        {/* ── Buttons ── */}
        <div className="flex gap-3 px-8 pb-8 pt-2">
          <button
            onClick={() => { onClose(); navigate('/org-admin/editprofile'); }}
            className="button flex-1 justify-center py-2.5"
          >
            <span>Complete Profile</span>
          </button>
        </div>

      </div>
    </div>
  );
};

export default CompleteProfileModal;